export default __webpack_public_path__ + "static/media/RailwayParts.30b04149.jpg";